module.exports = __webpack_public_path__ + "img/formato.46121e52.svg";